import React from 'react'
import classes from './TNC.module.css'
import { Accordion, Card } from 'react-bootstrap'
import SubSectionHeader from '../../Shared/SubSectionHeader'
import NotAvailable from '../NotAvailable'
const TNC = ({TNC=[]}) => {
    const AccordionBody=({AccordionItem,index})=>{
        return <Card className={classes['TNCcard']}>
       
        <Accordion.Toggle as={Card.Header} eventKey={index} className={classes['TNCCardHeader']}>
            {AccordionItem.label}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={index}>
            <Card.Body>
                {AccordionItem.value}
            </Card.Body>
        </Accordion.Collapse>
    </Card>
    }
    return (
        <div className={classes['Container']}>
            <SubSectionHeader title="Logistics Terms and Conditions" className={classes['title']}></SubSectionHeader>
            <div className={classes['Master']}>

            {
                TNC.length > 0 ?
                    <Accordion defaultActiveKey={0} className={classes['CustomAccordion']}>
                        {
                            TNC.map((item, index) => <AccordionBody AccordionItem={item} index={index} />)
                        }
                    </Accordion>
                    :
                    <NotAvailable />


            }
            </div>

        </div>
    )
}



export default TNC
